import common from './common';
import actionTypes from './action-types';

export default {
  common,
  actionTypes,
};
